import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { MyOrdersPage } from './my-orders.page';
import { SharedModuleModule } from '../../shared/shared-module.module';

const routes: Routes = [
	{
		path: '',
		component: MyOrdersPage,
	},
];

@NgModule({
	imports: [CommonModule, FormsModule, IonicModule, RouterModule.forChild(routes), SharedModuleModule],
	declarations: [MyOrdersPage],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MyOrdersPageModule {}
